import React from "react";
import LessonQuestionPaginationItemContainer from "./LessonQuestionPaginationItemContainer";
import { spacing } from "../library/theme";

const container = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  maxWidth: "100%",
  marginTop: spacing.s,
};

const buildEntryKey = (item) => {
  if (item.stem?.id) return `stem-${item.stem.id}`;
  if (item.isFlow) return `flow-${item.question.id}`;
  return `q-${item.question.id}`;
};

export default function LessonQuestionPagination({ flattenedLessonQuestions }) {
  return flattenedLessonQuestions?.length ? (
    <div style={container}>
      {flattenedLessonQuestions.map((item, index) => (
        <LessonQuestionPaginationItemContainer
          key={`${item.question.id}-${buildEntryKey(item)}`}
          index={index}
          question={item.question}
          stem={item.stem}
          isFlow={!!item.isFlow}
          displayIndex={item.displayIndex}
        />
      ))}
    </div>
  ) : null;
}
